module.exports = __webpack_public_path__ + "static/media/wheel-LITEGAME-TEMPLATE(old).png";